import type { FC } from 'react';
import * as React from 'react';

import QuestionOutline from '@crehana/icons/QuestionOutline';

import { FAQS_BY_STUDENT_TYPE } from '@/views/UserDashboard/constants';
import { useCrehanaTranslation } from '@/views/UserDashboard/hooks';
import type { StudentType } from '@/views/UserDashboard/types';

interface DesktopFAQsProps {
  studentType: StudentType;
  toggleTour: () => void;
}

const DesktopFAQs: FC<React.PropsWithChildren<DesktopFAQsProps>> = ({
  toggleTour,
  studentType,
}) => {
  const t = useCrehanaTranslation();

  return (
    <div className="flex flex-col" data-tour="sidebar-faq">
      <button
        type="button"
        className="flex items-center text-left font-label text-base-lighter py-8 pl-20"
        onClick={toggleTour}
      >
        <QuestionOutline size={24} ignoreColor className="mr-8 fill-current" />
        {t('UD_FAQ_ONBOARDING')}
      </button>
      {FAQS_BY_STUDENT_TYPE[studentType].map(({ key, href, text }) => (
        <a
          key={key}
          className="min-h-24 flex font-label text-base-lighter py-8 pl-20 mr-12"
          href={href}
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="h-24 w-24 mr-8">
            <QuestionOutline size={24} ignoreColor className="fill-current" />
          </div>
          {t(text)}
        </a>
      ))}
    </div>
  );
};

export default React.memo(DesktopFAQs);
